import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { MarketAreaSettings, UserModel } from "./../Models/ApplicationModels";

type UserState = {
  user: UserModel | null;
  setUser: (user: UserModel) => void;
  // updateUser: (partial: Partial<User>) => void;
  // clearUser: () => void;
};

export const userStore = create<UserState>()(
  // persist(
  (set) => ({
    user: null,
    setUser: (user) => set({ user }),
    // updateUser: (partial) =>
    //   set((state) =>
    //     state.user ? { user: { ...state.user, ...partial } } : state
    //   ),
    // clearUser: () => set({ user: null }),
  })
  //   {
  //     name: "app-user-store", // localStorage key
  //     storage: createJSONStorage(() => localStorage),
  //     // Persist only the user field
  //     partialize: (state) => ({ user: state.user }),
  //     version: 1,
  //   }
  // )
);

const initialMarketAreaSettings: MarketAreaSettings = {
  activeMarketArea: "",
  userMode: false,
};

type MarketAreaState = {
  marketAreaSettings: MarketAreaSettings;
  setMarketAreaSettings: (settings: MarketAreaSettings) => void;
};

export const useMarketAreaStore = create<MarketAreaState>()(
  persist(
    (set) => ({
      marketAreaSettings: initialMarketAreaSettings,

      // You only need to SET this once — no update/reset
      setMarketAreaSettings: (settings) =>
        set({ marketAreaSettings: settings }),
    }),
    {
      name: "app-market-area-store",
      storage: createJSONStorage(() => localStorage),

      // Persist only this piece of state
      partialize: (state) => ({
        marketAreaSettings: state.marketAreaSettings,
      }),

      version: 1,
    }
  )
);
